import React, { useState } from 'react';
import './index.scss';
import { Icon, TabPanel, Tabs } from 'tea-component';
import TabPanelContext from './TabPanelContext';
import useData from './_hooks'

export default function StrengthsTabCard(props: any) {
  const {
    tabs,
    topicSpanList,
    activeId,
    setActiveId,
    loading,
    language
  } = useData(props)
  return (
    <div className="dbi-strengthstab-card">
      <Tabs
        tabs={tabs}
        activeId={activeId}
        animated={false}
        onActive={(tab) => {
          if (activeId != tab.id) {
            setActiveId(tab.id);
          }
        }}
      />
      <div className="strengthstab-card-box">
        <div
          className = 
          {
            loading
              ? 'dbi-strengthstab-loading'
              : 'dbi-strengthstab-none'
          }
        >
          <Icon size="l" type="loading" />
          &nbsp;&nbsp;&nbsp;Loading…
        </div>
        <div 
          key={activeId} 
          style={(loading) ? {display:'none'} : {display:'unset'}}
        >
          <TabPanelContext tabList={topicSpanList} language={parseInt(language)}/>
        </div>
      </div>
    </div>
  );
}
